
<div class="kb-upload-container">
    <h3>{{'agentBuilder.kbtitle'|translateTA}}</h3>
    <div class="kb-list-container">
        <ul nz-list [nzDataSource]="data" nzBordered nzSize="large" [nzLoading]="loadingKB">
            @for (item of data; track item) {
            <li nz-list-item nzNoFlex>
                <ul nz-list-item-actions>
                    <nz-list-item-action>
                        <a (click)="removeKb(item)">{{'agentBuilder.removekb'|translateTA}}</a>
                    </nz-list-item-action>
                </ul>
                <nz-tag nzColor="blue">{{'agentBuilder.kbFileName'|translateTA}}: {{ item.source }}</nz-tag>
                <nz-tag nzColor="purple">{{'agentBuilder.kbKind'|translateTA}}: {{ item.kind }}</nz-tag>
                <nz-tag nzColor="yellow">{{'agentBuilder.kbChunks'|translateTA}}: {{ item.chunks }}</nz-tag>
                <!--nz-tag nzColor="brown">{{'agentBuilder.kbChunks'|translateTA}}: {{formatFile(item.fileSize)}} </nz-tag-->
                <nz-tag nzColor="green" *ngIf="item.status=='active'">{{'agentBuilder.kbactive'|translateTA}}</nz-tag>
                <nz-tag nzColor="red" *ngIf="item.status!='active'">{{'agentBuilder.kbinactive'|translateTA}}</nz-tag>
            </li>
            }
            <nz-list-footer>{{'agentBuilder.kbquantity'|translateTA}} : {{data.length}} | {{'agentBuilder.kbtotalchunks'|translateTA}} : {{getTotalChunks(data)}} </nz-list-footer>
        </ul>
    </div>

    <nz-upload
    [nzCustomRequest]="customUpload"
    [nzShowUploadList]="true"
    [nzMultiple]="true"
    [nzWithCredentials]="false"
    [nzBeforeUpload]="beforeUpload"
    (nzChange)="onChangeFileList($event)"
    [nzFileList]="fileListZorro">
    <button nz-button  [nzLoading]="loadingKB">
        <i nz-icon nzType="upload"></i>{{'agentBuilder.send.kb'|translateTA}} 
    </button>
    </nz-upload>
</div>
